export const toolVideos = {
  accumulate: {
    videoId: "S9-0oMFuK8M",
    title: "Structura Accumulate: One Line, One Zone, Rare Stamp",
    caption: "Accumulate in 60 seconds: the line, the stamp, the zone, the counter - and what the layer never tells you.",
    uploadDate: "2026-10-24",
    duration: "PT1M1S",
  },
  divergence: {
    videoId: "RNWbYWrqP7s",
    title: "Structura Divergence: Four Kinds of Disagreement",
    caption: "Divergence in 50 seconds: four kinds of disagreement between price and momentum - and what the layer never tells you.",
    uploadDate: "2026-10-24",
    duration: "PT53S",
  },
  blocks: {
    videoId: "Zt1-2U-cvVE",
    title: "Structura Blocks: Fair Value Gaps, Read Honestly",
    caption: "Blocks in 60 seconds: fair value gaps, marked and kept - and what the layer never tells you.",
    uploadDate: "2026-10-22",
    duration: "PT1M",
  },
  sentinel: {
    videoId: "QyQojg8zWJg",
    title: "Structura Sentinel: One Table Before the Session",
    caption: "Sentinel in 50 seconds: one table before the session - where to look, not what to trade.",
    uploadDate: "2026-10-24",
    duration: "PT50S",
  },
  pulse: {
    videoId: "qcYfZ3FavnY",
    title: "Structura Pulse: Five States of a Trend Cycle",
    caption: "Pulse in 55 seconds: five states of a trend cycle - and why it never says buy or sell.",
    uploadDate: "2026-10-24",
    duration: "PT54S",
  },
};

export function toolVideoEmbedUrl(videoId) {
  return `https://www.youtube-nocookie.com/embed/${videoId}?rel=0&modestbranding=1&autoplay=1`;
}

export function toolVideoSchema(slug) {
  const video = toolVideos[slug];
  if (!video) return null;
  return {
    "@context": "https://schema.org",
    "@type": "VideoObject",
    name: video.title,
    description: video.caption,
    thumbnailUrl: `https://i.ytimg.com/vi/${video.videoId}/maxresdefault.jpg`,
    embedUrl: toolVideoEmbedUrl(video.videoId),
    uploadDate: video.uploadDate,
    duration: video.duration,
  };
}
